import axios from "axios";
import { Message } from "element-ui";
import store from "../../store/store";
import router from "../../router/index";
// import _this from "../../main";
import * as cookie from "../../untils/cookie";


// const loadingInstance = Loading.service;
import { Loading } from "element-ui";
let loading;
function startLoading() {
  loading = Loading.service({
    lock: true,
    text: "Loading",
    spinner: "el-icon-loading",
    background: "rgb(242, 242, 242,0.7)"
  });
}

function endLoading() {
  loading.close();
}

import vue from "../../main";
// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//   axios.defaults.baseURL = 'https://www.baidu.com';}
// else if (process.env.NODE_ENV == 'debug') {
//   axios.defaults.baseURL = 'https://www.ceshi.com';
// }
// else if (process.env.NODE_ENV == 'production') {
//   axios.defaults.baseURL = 'https://www.production.com';
// }
let Culture = "fr";
let AspNetCoreCulture = cookie.getItem("AspNetCoreCulture");
if (AspNetCoreCulture) {
  Culture = AspNetCoreCulture == "zh" ? "fr" : "en";
}
var instance = axios.create({ timeout: 1000 * 60 });
instance.defaults.timeout = 60 * 1000; //请求超时30秒
instance.defaults.baseURL = ""; //请求base url
instance.defaults.headers.post["Content-Type"] = "application/json-patch+json"; //设置post请求是的header信息

// instance.defaults.withCredentials = true //你要用到session验证码功能，让请求携带cookie，可以加上以下一行：

//http request 拦截器
instance.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data);
    config.headers = {
      "Content-Type": "application/json-patch+json",
      Authorization: "Bearer " + store.state.permission.token,
      "Access-Control-Allow-Origin": "*",
      "Access-Control-Allow-Methods": "POST,GET,OPTIONS,DELETE",
      "Access-Control-Allow-Headers": "x-requested-with,content-type"
    };
    config.headers["url"] = router.currentRoute.path;
    config.headers[".AspNetCore.Culture"] = Culture;
    // console.log(config);

    // const token = getCookie('名称');//注意使用的时候需要引入cookie方法，推荐js-cookie
    // if(token){
    //   config.params = {'token':token}
    // }
    // if (config.method === 'post') {
    //   if (config.headers['Content-Type'] !== 'application/json') {
    //     // config.headers['Content-Type']
    //     config.headers['Content-Type'] = 'multipart/form-data'
    //   } else {
    //     config.data = config.data;
    //   }
    // }
  //  loadingInstance({ fullscreen: true }); 
    if (config.url.indexOf("Home/GetredisCache") == -1 && config.url.indexOf("Home/SetredisCache") == -1){
      startLoading();
    }
    
    // console.log(loading);
    return config;
  },
  error => {
    endLoading();
    return Promise.reject(err);
  }
);

//http request 拦截器
// instance.interceptors.request.use(
//   config => {
//     let token = sessionStorage.getItem('token')
//     if (token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
//       config.headers = {
//         'X-token': token
//       }
//     }
//     return config
//   },
//   err => {
//     return Promise.reject(err)
//   }
// )

//http response 拦截器
instance.interceptors.response.use(
  
   
  response => {
    endLoading();
    // if (sessionStorage) {
    //   const token = sessionStorage.getItem(apiconfig.TOKEN_KEY)
    //   if (token) {
    //     config.headers['Authorization'] = 'bearer ' + token // 让每个请求携带token--['X-Token']为自定义key 请根据实际情况自行修改
    //   }
    //   return config
    // } else {
    //   Notification({
    //     title: '错误',
    //     message: '您的浏览器版本太低,请升级浏览器',
    //     type: 'error'
    //   })
    // }
    // if (response.status === UNAUTHORIZED_CODE) { //与后台约定登录失效的返回码
    //   store.dispatch('initLoginModal', { state: true });        //显示登录弹窗
    //   store.dispatch('removeUser');                      //移出浏览器中存储的用户信息
    // }
    if (response.status === 200) {
      const { data } = response;
      if (data.error === undefined || data.error === null) {
        return response;
      }
      if (!data.success) {
        let msg = "";
        if (data.error.code == 404) msg = vue.$t("message.not_found");
        else if (data.error.code == 500) msg = vue.$t("message.server_error");
        else if (data.error.code == 400)
          msg = vue.$t("message.Request_parameter_error");
        if (msg == "") return response;
        Message({
          message: msg,
          type: "warning"
        });
      }
      //处理请求成功的逻辑
      return response; // 必须返回，后面的接口的then，才能获取response
    } else {
      if (response.status == 500) {
        Message({
          message: vue.$t("message.Interface_address_error"),
          type: "warning",
          timeout: 1500,
          callback: () => {
            router.go(-1);
          }
        });
        // 错误处理
      } else if (response.status === 404) {
        Message({
          message: vue.$t("message.Interface_address_error"),
          type: "warning",
          timeout: 1500,
          callback: () => {
            router.go(-1);
          }
        });
        //跳转页面
        router.push({
          path: "/Video",
          query: {
            redirect: router.currentRoute.fullPath
          }
        });
      }
      return reponse; // 必须返回
    }
    // if(response.data.errCode ==2){
    //   router.push({
    //     path:"/login",
    //     query:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
    //   })
    //}
    return response;
  },
  error => {
    endLoading();
    var errorMsg = "";
    if (error.toString().indexOf("Network Error") !== -1) {
      Message({
        message: "服務器接口未啟動",
        type: "warning",
        timeout: 800
      });
      return Promise.reject(error.toString());
    }
    if (error.response.status === 401) {
      //跳转页面
      errorMsg = vue.$t("message.information");
      let errData = error.response.data;
      if (errData == "true" || errData == "True") {
        router.push({
          path: "/login",
          query: {
            redirect: router.currentRoute.fullPath
          }
        });
      } else {
        // console.log(router);
        if (router.currentRoute.name !== "customerLogin") {
          router.push({
            path: "/customerLogin",
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
        }
      }
    }
    if (error.response.status === 605) {
      //跳转页面
      errorMsg = vue.$t("message.permission");
      // router.push({
      //   path: "/login",
      //   query: {
      //     redirect: router.currentRoute.fullPath
      //   }
      // })
    }
    if (error.toString().indexOf("timeout") !== -1) {
      errorMsg = vue.$t("message.server_timed_out");
    } else {
      const errorStatus = error.response.status;
      const resErrorMsg = errorStatus + ":" + error.response.data.message;
      switch (errorStatus) {
        case 403:
          errorMsg = vue.$t("message.have_no_right");
          break;
        case 404:
          errorMsg = vue.$t("message.path_not_found");
          break;
        case 405:
          errorMsg = vue.$t("message.path_not_found");
          break;
        case 500:
          errorMsg = vue.$t("message.server_error");
          break;
        case 422:
          errorMsg =
            resErrorMsg + ":" + JSON.stringify(error.response.data.data);
          break;
      }
    }

    Message({
      message: errorMsg,
      type: "warning",
      timeout: 800,
      callback: () => {
        router.go(-1);
      }
    });
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, param = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: param
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

export function postupload(url, method, data = {}, processData, contentType) {
  return new Promise((resolve, reject) => {
    axios.post(url, method, data, processData, contentType).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
export default instance;



// WEBPACK FOOTER //
// ./src/api/httpApi/http.js